import { createApp } from 'vue'
import './style.scss'
import App from './App.vue'
import { registerLicense } from '@syncfusion/ej2-base';
import { router } from './router/routes';
import { createPinia } from 'pinia';
import { setupLocale } from './confs/locale';
import VueTheMask from 'vue-the-mask'

registerLicense(import.meta.env.VITE_SYNCFUSION_KEY);

setupLocale()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(VueTheMask as any)

app.config.errorHandler = (err, _instance, info) => {
  console.error('[Vue error]', err, info);
};

app.mount('#app')
